/* BDFHYK PDP Promotion Banner V1.1 */
(function(){
  function init(root){
    if(root.dataset.bdfReady==='true')return;
    root.dataset.bdfReady='true';
    if(root.dataset.priceEligible!=='true')return;
    var output=root.querySelector('[data-bdf-estimated-price]');
    var node=root.querySelector('[data-bdf-pdp-variants]');
    if(!output||!node)return;
    var variants=[];
    try{variants=JSON.parse(node.textContent)}catch(e){return}
    var moneyFormat=root.dataset.moneyFormat||'${{amount}}';
    function money(cents){
      var number=(cents/100).toFixed(2),comma=number.replace(/\B(?=(\d{3})+(?!\d))/g,',');
      return moneyFormat.replace(/\{\{\s*(amount|amount_with_comma_separator|amount_no_decimals|amount_no_decimals_with_comma_separator)\s*\}\}/g,function(_,key){
        if(key==='amount')return number;
        if(key==='amount_with_comma_separator')return comma;
        var rounded=String(Math.round(cents/100));
        return key==='amount_no_decimals'?rounded:rounded.replace(/\B(?=(\d{3})+(?!\d))/g,',');
      });
    }
    function update(id){
      var variant=variants.find(function(v){return String(v.id)===String(id)});
      if(!variant)return;
      var value=Number(root.dataset.discountValue)||0,price=Number(variant.price)||0;
      var result=root.dataset.discountType==='percentage'?Math.round(price*(1-Math.min(value,100)/100)):Math.max(0,price-Math.round(value*100));
      output.textContent=money(result);
    }
    function currentId(){
      var fromUrl=new URLSearchParams(location.search).get('variant');
      if(fromUrl)return fromUrl;
      var info=root.closest('.shopify-section')?.parentElement||document;
      var form=info.querySelector('form[action*="/cart/add"] input[name="id"]')||document.querySelector('form[action*="/cart/add"] input[name="id"]');
      return form&&form.value;
    }
    function refresh(){var id=currentId();if(id)update(id)}
    document.addEventListener('change',function(e){
      if(e.target&&e.target.name==='id')update(e.target.value);
      else requestAnimationFrame(refresh);
    });
    ['variant:change','variant:changed','product:variant-change'].forEach(function(name){document.addEventListener(name,function(e){var v=e.detail&&(e.detail.variant||e.detail);if(v&&v.id)update(v.id);else requestAnimationFrame(refresh)})});
    window.addEventListener('popstate',refresh);
    var last='';
    var observer=new MutationObserver(function(){var id=currentId();if(id&&id!==last){last=id;update(id)}});
    var form=document.querySelector('form[action*="/cart/add"]');
    if(form)observer.observe(form,{subtree:true,childList:true,attributes:true,attributeFilter:['value']});
    refresh();
  }
  function scan(){document.querySelectorAll('[data-bdf-pdp-promo]').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan);else scan();
  document.addEventListener('shopify:section:load',scan);
})();